export const ROLE_CLIENT = "CLIENT";
export const ROLE_STAFF = "STAFF";
export const ROLE_MANAGER = "MANAGER";
export const ROLE_ADMIN = "ADMIN";

export const PERMISSION_JOBS_JOB_DELETE = "JOBS_JOB_DELETE";
export const PERMISSION_JOBS_JOB_EDIT_DATE = "JOBS_JOB_EDIT_DATE";
export const PERMISSION_JOBS_TIME_TRACKING_VIEW_OTHERS = "JOBS_TIME_TRACKING_VIEW_OTHERS";

export type Role = {
  uuid: string,
  name: string,
  name_readable: string,
}

export type Permission = {
  uuid: string,
  name: string,
  name_readable: string,
}

export type RolePermission = {
  permission: Permission,
  is_allowed: boolean
}

export type UserPermissions = {
  role: string,
  permissions: string[]
}

export type CompanyRolePermissions = {
  role: Role,
  permissions: RolePermission[]
}